import i18n from 'i18next';
import dadkImages from './da-dk.json';
import dedeImages from './de-de.json';
import enauImages from './en-au.json';
import engbImages from './en-gb.json';
import enusImages from './en-us.json';
import esesImages from './es-es.json';
import esusImages from './es-us.json';
import fifiImages from './fi-fi.json';
import frcaImages from './fr-ca.json';
import frfrImages from './fr-fr.json';
import ititImages from './it-it.json';
import nbnoImages from './nb-no.json';
import nlnlImages from './nl-nl.json';
import ptptImages from './pt-pt.json';
import svseImages from './sv-se.json';

// responsible for the localisation of images
export function __image(translationKey: string): string {
    return i18n.t(translationKey);
}

export const imageTranslations = {
    dadkImages,
    dedeImages,
    enauImages,
    engbImages,
    enusImages,
    esesImages,
    esusImages,
    fifiImages,
    frcaImages,
    frfrImages,
    ititImages,
    nbnoImages,
    nlnlImages,
    ptptImages,
    svseImages,
};
